import { PublicKey, Transaction } from '@solana/web3.js';
import { NATIVE_SOL_ADDRESS } from '../../constants.js';
import { encoder, hexToUint8Array } from '../../utils.js';
export async function buildRefundTx(connection, program, walletPublicKey, params) {
    if (!params.contractAddress)
        throw new Error('No contract address');
    const hashlockBytes = hexToUint8Array(params.id.replace('0x', ''));
    const hashlockArray = Array.from(hashlockBytes);
    const [userLockPda] = PublicKey.findProgramAddressSync([encoder.encode('user_lock'), hashlockBytes], program.programId);
    let refundIx;
    if (params.sourceAsset.contract && params.sourceAsset.contract !== NATIVE_SOL_ADDRESS) {
        const { getAssociatedTokenAddress, TOKEN_PROGRAM_ID, ASSOCIATED_TOKEN_PROGRAM_ID } = await import('@solana/spl-token');
        const tokenMint = new PublicKey(params.sourceAsset.contract);
        const senderTokenAccount = await getAssociatedTokenAddress(tokenMint, walletPublicKey);
        const [vault] = PublicKey.findProgramAddressSync([encoder.encode('user_vault'), hashlockBytes], program.programId);
        refundIx = await program.methods
            .refundUserToken(hashlockArray)
            .accounts({
            caller: walletPublicKey,
            userLock: userLockPda,
            sender: walletPublicKey,
            tokenMint,
            vault,
            senderTokenAccount,
            tokenProgram: TOKEN_PROGRAM_ID,
            associatedTokenProgram: ASSOCIATED_TOKEN_PROGRAM_ID,
        })
            .instruction();
    }
    else {
        refundIx = await program.methods
            .refundUserSol(hashlockArray)
            .accounts({
            caller: walletPublicKey,
            userLock: userLockPda,
            sender: walletPublicKey,
        })
            .instruction();
    }
    const { blockhash, lastValidBlockHeight } = await connection.getLatestBlockhash();
    const tx = new Transaction();
    tx.recentBlockhash = blockhash;
    tx.lastValidBlockHeight = lastValidBlockHeight;
    tx.feePayer = walletPublicKey;
    tx.add(refundIx);
    return tx;
}
